import { useQuery } from "react-query";
import { filterCategory } from "./helpers";

const useLandUseData = ({ id, tenantId, userInfo, usersData, applicationFlow, validity, userUid }) => {
  const isEditMode = !!id;
  console.log("logginFromNewHookCreate", id, isEditMode);
  const consultantCategory = filterCategory(userInfo?.roles);
  const fetchApplicationData = async () => {
    return await Digit.OBPSService.BPASearchFormLandUse(tenantId, { applicationNo: id });
  };

  const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({
    queryKey: ["landUseData", id],
    queryFn: fetchApplicationData,
    enabled: isEditMode, // ✅ only fetch when id exists
  });

  const applicationData =
    isEditMode && isSuccess
      ? data?.LandUse?.[0]
      : {
          tenantId,
          professionalInformation: {
            name: userInfo?.name,
            mobileNumber: userInfo?.mobileNumber,
            consultantCategory: consultantCategory,
            emailId: userInfo?.emailId,
            planDate: validity,
            address: {
              address: userInfo?.permanentAddress,
              district: null,
              state: null,
            },
            certificateNumber: usersData?.[0]?.registrationArchitectNumber,
            licenseNumber: usersData?.[0]?.registrationNumber,
            planDate: validity,
            // registrationNumber: userInfo?.registrationNumber,
            // registrationArchitectNumber: registrationArchitectNumber,
          },
          department: applicationFlow,
          landAreaDetails: {
            city: null,
            locality: null,
            village: null,
            areaType: null,
          },
          descriptionOfLand: {
            revenueVillageMohal: null,
            propertyType: null,
            khataNo: null,
            multipleKhasra: [{ khasraNo: "", area: "" }],
            khatauniNo: null,
            areaForCluSqM: 0,
            nameofConcerned: null,
            natureOfTower: null,
            towerToBeProposed: null,
            proposedGoundCoverageSqM: null,
            whetherUsedBySingleCompany: null,
            installationFeesDeposited: null,
            nameofConcerned: null,
            sectorNo: null,
            schemeName: null,
            approachRoadWidths: null,
            totalPlotArea: 0,
            appliedLandUse: {
              name: null,
            },
            whetherUsedBySingleCompany: null,
            propertyType: {
              name: null,
            },
            installationFeesDeposited: null,
            isChangeOfLandInvolved: null,
            typeOfCLUInvolved: {
              name: null,
            },
          },
          activeTab: sessionStorage.getItem("LANDUSE_CURRENT_TAB") || 0,
          applicationType: "FORM_LANDUSE",
          feeType: "ApplicationFee",
          workflow: { action: "INITIATE" },
          landInfo: {
            owners: [
              {
                name: null,
                fatherOrHusbandName: null,
                aadhaarNumber: "",
                mobileNumber: "",
                emailId: "",
                gender: null,
                correspondenceAddress: {
                  applicantName: null,
                  applicantGuardianName: null,
                  state: "",
                  district: null,
                  tehsil: null,
                  town: null,
                  address: "",
                  pinno: "",
                  type: "CORRESPONDENCE",
                },
                permanentAddress: {
                  applicantName: null,
                  applicantGuardianName: null,
                  state: "",
                  district: null,
                  tehsil: null,
                  town: null,
                  address: "",
                  pinno: "",
                  type: "PERMANENT",
                },
              },
            ],
            tenantId,
          },
          nocDetails: {
            applicantNOCData: null,
            additionalApplicantNOC: null,
            officerNOCData: null,
            additionalOfficerNOC: null,
            checkedByOfficer: null,
          },
          businessService: null,
          documents: [],
          // [
          //   {
          //     documentType: "applicantPhoto",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Photo",
          //     },
          //   },
          //   {
          //     documentType: "signature",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Signature",
          //     },
          //   },
          //   {
          //     documentType: "completeDrawingFile",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Complete drawing including Location/Site plan, Key plan, Site Superimposed on Master plan",
          //     },
          //   },
          //   {
          //     documentType: "kmlFile",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "KML File",
          //     },
          //   },
          //   {
          //     documentType: "sajraPlan",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Site Superimposed on Sajra Plan",
          //     },
          //   },
          //   {
          //     documentType: "landOwnershipDoc",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Land Ownership Document",
          //     },
          //   },
          //   {
          //     documentType: "allotmentLetter",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Allotment letter",
          //     },
          //   },
          //   {
          //     documentType: "possessionLetter",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Possesion letter",
          //     },
          //   },
          //   {
          //     documentType: "registrySaleDeedHPTA",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Registery/Sale deed/HPTA",
          //     },
          //   },
          //   {
          //     documentType: "giftDeed",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Gift Deed",
          //     },
          //   },
          //   {
          //     documentType: "developerConsortiumSalesAgreement",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Developer/Consortium/Sales Agreement",
          //     },
          //   },
          //   {
          //     documentType: "khatauni",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "Khatauni",
          //     },
          //   },
          //   {
          //     documentType: "mutationLetter",
          //     fileStoreId: null,
          //     additionalDetails: {
          //       fileName: null,
          //       title: "mutationLetter",
          //     },
          //   },
          // ],

          uiFlow: { flow: "Form_LANDUSE" },
        };

  return { applicationData, isAppDataLoading };
};
export default useLandUseData;
